import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
import { ReactComponent as CheckCircleFill } from "bootstrap-icons/icons/check-circle-fill.svg";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import CustomStyles from "../../components/utils/CustomStyles";
import formatDate from "../../components/utils/DateFormatter";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
const VendorWithdrawaReqList = () => {
  const [vendorWithdrawalRequest, setVendorWithdrawalRequest] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState("");
  const { permissions } = useContext(AuthContext);
  // console.log("permissions", permissions);
  const navigate = useNavigate();

  // const { vendorId } = location.state || {};
  // console.log("vendor id", vendorId);

  // ==========================- fetch all vendorWithdrawalRequest =================
  useEffect(() => {
    const fetchWithdrawalRequestList = async () => {
      setLoading(true);
      try {
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) {
          throw new Error("No access token found.");
        }
        // console.log("i am token", token);
        const response = await axios.get(ApiServices.getVendorWithrawalRequest, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        // console.log("this is all vendor", response.data);
        const { status, message, data } = response.data;
        if (status === 200) {
          setVendorWithdrawalRequest(data);
          toast.success(message, { toastId: "vendor-fetch-success" });
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawalRequestList();
  }, [navigate]);
  // ================================== end of list of vendor ==========================================

  //filter data by name
  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // const handleUserTypeSelect = (type) => {
  //   setSelectedUserType(type);
  //   setIsDropdownOpen(false);
  // };


  // Define Expandable Component for Actions
  const ExpandableComponent = ({ data }) => {
    // console.log("ExpandableComponent data:", data);
    // console.log("ExpandableComponent status:", JSON.stringify(data?.status));

    return (
      <div className="flex justify-start p-4 relative space-x-4">

        {/* Details Button with Tooltip */}
        {permissions.some(permission => permission.name === 'withdrawal.view') && (
          <div className="relative group">
            <Link
              to="/admin/vendor/withdrawal/details"
              state={{ data }}
              className="btn btn-info btn-sm"
            >
              <Eye className="w-5 h-5 text-orange1 mx-2" />
            </Link>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block bg-white  text-orange1 text-xs px-2 py-1 rounded">
              Details
            </div>
          </div>
        )}

        {/* First Approval */}
        {permissions.some(permission => permission.name === 'withdrawal.process') && (
          <>
            {(!data?.status || data?.status.trim().toLowerCase() === "pending") && (
              <div className="relative group">
                <Link
                  to="/admin/vendor/withdrawal/request/approval"
                  state={{ data }}
                  className="btn btn-info btn-sm"
                >
                  <CheckCircleFill className="w-5 h-5 text-darkGreen3 mr-3" />
                </Link>
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block bg-white text-dash4 text-xs px-2 py-1 rounded">
                  First Approval
                </div>
              </div>
            )}

            {/* Second Approval */}
            {(data?.status && ["processing", "approved"].includes(data.status.trim().toLowerCase())) && (
              <div className="relative group">
                <Link
                  to="/admin/vendor/withdrawal/request/approval"
                  state={{ data }}
                  className="btn btn-info btn-sm"
                >
                  <CheckCircleFill className="w-5 h-5 text-dash4 mr-3" />
                </Link>
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block bg-white text-dash4 text-xs px-2 py-1 rounded">
                  Second Approval
                </div>
              </div>
            )}
          </>
        )}

      </div>
    );
  };


  const columns = [
    {
      name: "Reference",
      selector: (row) => row.reference,
      sortable: true,
      width: "250px",
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
      width: "150px",
      cell: (row) => <span className="font-bold">{CurrencyFormatter(row.amount)}</span>,
    },
    {
      name: "Net Amount",
      selector: (row) => row.net_amount,
      sortable: true,
      width: "150px",
      cell: (row) => <span className="text-green-600">{CurrencyFormatter(row.net_amount)}</span>,
    },
    {
      name: "Withdrawal Method",
      selector: (row) => row.withdrawal_method,
      sortable: true,
      width: "200px",
      cell: (row) => row.withdrawal_method.replace("_", " ").toUpperCase(),
    },
    {
      name: "Bank Details",
      sortable: false,
      width: "300px",
      cell: (row) => (
        <div className="flex flex-col space-y-1">
          {/* Account Name */}
          <span className="block font-bold text-gray-800">
            {row.bank_details?.account_name
              ? row.bank_details.account_name.toUpperCase()
              : "NOT AVAILABLE"}
          </span>

          {/* Bank Name */}
          <span className="inline-block px-2 py-0.5 rounded-md bg-orange1 text-lGrey2 text-xs">
            {row.bank_details?.bank_name
              ? row.bank_details.bank_name
              : "NOT AVAILABLE"}
          </span>

          {/* Account Number */}
          <span className="inline-block px-2 py-0.5 rounded-md bg-darkGreen3 text-lGrey2 text-xs">
            {row.bank_details?.account_number
              ? row.bank_details.account_number
              : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status_label,
      sortable: true,
      width: "180px",
      cell: (row) => {
        let badgeClass = "bg-gray-300 text-gray-800 px-2 py-1 rounded";

        if (row.status_badge === "warning") badgeClass = "bg-yellow-200 text-yellow-800 px-2 py-1 rounded";
        if (row.status_badge === "success") badgeClass = "bg-green-200 text-green-800 px-2 py-1 rounded";
        if (row.status_badge === "danger") badgeClass = "bg-red-200 text-red-800 px-2 py-1 rounded";

        return <span className={badgeClass}>{row.status_label}</span>;
      },
    },
    {
      name: "Date",
      selector: (row) => row.created_at,
      sortable: true,
      width: "200px",
      cell: (row) => formatDate(row.created_at),
    },
  ];



  // filter data
  const filteredItems = vendorWithdrawalRequest.filter((item) => {
    return Object.values(item).some((val) =>
      val?.toString().toLowerCase().includes(filterText.toLowerCase())
    );
  });

  // map the filtered items
  const data = filteredItems.map((vendor) => ({
    joined_date: vendor.joined_date,
    firstname: vendor.firstname
      ? vendor.firstname.toUpperCase()
      : "NOT AVAILABLE",
    lastname: vendor.lastname ? vendor.lastname.toUpperCase() : "NOT AVAILABLE",
    email: vendor.email ? vendor.email.toUpperCase() : "NOT AVAILABLE",
    phone_number: vendor.phone_number ? vendor.phone_number : "NOT AVAILABLE",
    status: vendor.status ? vendor.status.toUpperCase() : "NOT AVAILABLE",
    vendor_id: vendor.vendor_id,
    reference: vendor.reference,
    amount: vendor.amount,
    net_amount: vendor.net_amount,
    withdrawal_method: vendor.withdrawal_method,
    bank_details: vendor.bank_details,
    status_label: vendor.status_label,
    status_badge: vendor.status_badge,
    created_at: vendor.created_at,
    withdrawal_id: vendor.withdrawal_id,
    admin_reference: vendor.admin_reference,
    rejection_reason: vendor.rejection_reason,
    admin_notes: vendor.admin_notes,
    processed_by: vendor.processed_by,
    processed_at: vendor.processed_at,
  }));

  // sort after mapping
  const sortedData = [...data].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );



  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section
            className="w-full pl-[3%] pr-[3%] pt-3 my-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <nav className="bg-gray-200 py-0 px-0 rounded-lg ">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3">
                    Vendor
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3">
                    Withdrawal
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">Request</p>
                </li>
              </ol>
            </nav>
          </section>
          <div className="w-full flex flex-col sm:flex-row sm:space-x-4 mb-4">
            {/* Search Input */}
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 
                 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search"
                value={filterText}
                onChange={handleFilter}
              />
            </div>

            {/* Dropdown Filter */}
            {/* <div className="relative w-full sm:w-1/2">
              {permissions.some((permission) => permission.name === "customer.view") && (
                <button
                  type="button"
                  className="bg-darkGreen3 inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-3 text-sm font-semibold text-dGrey3"
                  id="menu-button"
                  aria-expanded={isDropdownOpen}
                  aria-haspopup="true"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Select Type
                  <svg
                    className="-mr-1 h-5 w-5 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}

              {isDropdownOpen && (
                <div
                  className="absolute right-0 z-10 mt-2 w-full sm:w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                >
                  <div className="py-1 rounded-md bg-white" role="none">
                    <button
                      onClick={() => handleUserTypeSelect("vendor")}
                      className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3"
                    >
                      Vendor
                    </button>
                    <button
                      onClick={() => handleUserTypeSelect("rider")}
                      className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3"
                    >
                      Rider
                    </button>
                    <button
                      onClick={() => handleUserTypeSelect("")} // Reset filter
                      className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3"
                    >
                      All
                    </button>
                  </div>
                </div>
              )}
            </div> */}
          </div>


          {loading ? (
            <Spinner loading={loading} />
          ) : (
            // <DataTable
            //   columns={columns}
            //   data={sortedData}
            //   pagination
            //   striped
            //   responsive
            //   highlightOnHover
            //   noDataComponent={<div>No vendor found</div>}
            //   customStyles={CustomStyles}
            // />
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              striped
              highlightOnHover
              customStyles={CustomStyles}
              noDataComponent={<div>No vendor  found</div>}
              expandableRows
              expandableRowsComponent={ExpandableComponent}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default VendorWithdrawaReqList;
